import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchEpgBySearch } from '../../api/searchApi';
import { FETCH_STATUS_FAILED, FETCH_STATUS_LOADING, FETCH_STATUS_SUCCESS } from '../constants';

const initialState = {
  search: {
    status: 'idle',
    limit: 0,
    offset: 0,
    telecastList: [],
    error: null
  }
};

export const fetchTelecastBySearch = createAsyncThunk(
  'telecastSearch/fetchTelecastBySearch',
  async ({ text, categoryId = '', limit, offset }, thunkAPI) => {
    return await fetchEpgBySearch(text, categoryId, limit, offset, {
      signal: thunkAPI.signal
    });
  }
);

const telecastSearchSlice = createSlice({
  name: 'telecastSearch',
  initialState,
  reducers: {
    setInitialTelecastList: (state) => {
      state.search.telecast = initialState.search.telecastList;
    }
  },
  extraReducers: {
    [fetchTelecastBySearch.pending]: (state) => {
      state.search = { ...initialState.search, status: FETCH_STATUS_LOADING };
    },
    [fetchTelecastBySearch.fulfilled]: (state, action) => {
      state.search.status = FETCH_STATUS_SUCCESS;
      state.search.telecastList = action.payload.data.tv_channels_with_epg_list;
      state.search.limit = action.payload.data.limit;
      state.search.offset = action.payload.data.offset;
    },
    [fetchTelecastBySearch.rejected]: (state, action) => {
      state.search.status = FETCH_STATUS_FAILED;
      state.search.error = action.error;
    }
  }
});

export const getTelecastSearchList = (state) => state.telecastSearch.search.telecastList;
export const getTelecastSearchStatus = (state) => state.telecastSearch.search.status;
export const getTelecastSearchError = (state) => state.telecastSearch.search.error;
export const getTelecastSearchOffset = (state) => state.telecastSearch.search.offset;
export const getTelecastSearchLimit = (state) => state.telecastSearch.search.limit;

export const { setInitialTelecastList } = telecastSearchSlice.actions;

export default telecastSearchSlice.reducer;
